import { SegmentSchema } from '@sondermind/segment';
import { IPslPageLoadEventData } from './segment-event-data.interface';

export enum PslSegmentEvents {
  PSL_SEND_REQUEST_A_SESSION_EMAIL = 'send-psl-session-request-email',
  PSL_PAGE_VIEW = 'Viewed a provider shareable link page'
}

export interface IPslSegmentSchema extends SegmentSchema {
  [PslSegmentEvents.PSL_SEND_REQUEST_A_SESSION_EMAIL]: {};
  [PslSegmentEvents.PSL_PAGE_VIEW]: IPslPageLoadEventData;
}
